import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, of } from 'rxjs';
import { switchMap, catchError, filter } from 'rxjs/operators';

import { ProjectApiService } from './project-api.service';
import { ProjectStorageService } from './project-storage.service';
import { TaskType } from '../types/task-type';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private api = inject(ProjectApiService);
  private storage = inject(ProjectStorageService);
  private projectsSubject$ = new BehaviorSubject<any>([]);
  public projects$ = this.projectsSubject$.asObservable();

  constructor() {
    this.loadProjects();
  }

  refreshProjects() {
    return this.api.getScheduled()
      .pipe(
        catchError(_ => {
          return of(); // error catched, subject has projects from cache
        }),
        switchMap(projects => {
          projects.forEach(project => {
            project.tasks = this.transformTasks(project);
          });
          return of(projects);
        }),
        switchMap(projects => {
          this.projectsSubject$.next(projects);
          return this.storage.save(projects);
        }),
      );
  }

  private loadProjects() {
    this.storage.get()
      .pipe(
        filter(projects => !!projects)
      )
      .subscribe(projects => {
        this.projectsSubject$.next(projects);
      });
  }

  // Sortierung: Fahrt zuoberst, dann Haupttask (Arbeit), dann restliche Aufgaben
  private transformTasks(project) {
    const taskTypeCodeJourney = 1; // wie SwissIsol
    const tasks = project.tasks;

    // Fahrt
    const journeyTask = tasks.find(t => t.taskTypeCode === taskTypeCodeJourney);
    if (journeyTask) {
      journeyTask.taskType = TaskType.Journey;
    }

    // Arbeit
    const mainTask = tasks[0].taskTypeCode !== taskTypeCodeJourney ? tasks[0] : null; // Haupttask ist 1. Aufgabe, aber nicht Fahrt
    if (mainTask?.name === project.name) { // nur als 'Haupttask' wenn gleich wie Projektname
      mainTask.taskType = TaskType.Main
    }

    // Weitere
    const otherTasks = tasks.filter(t =>
      t.projectTaskId !== mainTask?.projectTaskId &&
      t.projectTaskId !== journeyTask?.projectTaskId
    );
    otherTasks.forEach(t => t.taskType = TaskType.Other);

    return [journeyTask, mainTask, ...otherTasks].filter(t => !!t);
  }

}
